import { FunctionComponent } from 'react';
import getConfig from 'next/config';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import BreadCrumbs from 'components/layout/BreadCrumbs/component';
import Button from 'components/layout/Button';
import { ButtonStyles, ButtonVariants } from 'components/layout/Button/types';
import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PageRegulationsSectionContent: FunctionComponent<Props> = ({ translations }) => {
    const router = useRouter();
    const { publicRuntimeConfig } = getConfig();

    return (
        <StyledComponent className="page-regulations-section-content">
            <LayoutContainer className="regulations">
                <BreadCrumbs
                    elements={[{
                        key: 'home',
                        href: { pathname: Routes.PublicHome },
                        label: translations?.breadCrumsHome,
                        active: false,
                        disableDivider: true,
                    }, {
                        key: 'regulations',
                        href: { pathname: Routes.PublicRegulations },
                        label: translations?.breadCrumsRegulations,
                        active: true,
                        disableDivider: false,
                    }]}
                />
                <section className="regulations-data">
                    <LayoutContainer size={Sizes.XSmall}>
                        <header className="regulations-header">
                            <h1 className="regulations-header-headline">
                                {translations?.headline}
                            </h1>
                            <Button
                                className="regulations-header-button desktop"
                                style={ButtonStyles.TextCTA}
                                onClick={() => router.push(Routes.PublicPdfRegulations)}
                            >
                                {translations?.downloadButton}
                            </Button>
                            <Button
                                className="gradient-180 mobile"
                                style={ButtonStyles.Primary}
                                variant={ButtonVariants.Primary}
                                onClick={() => window.open(`https://docs.google.com/gview?embedded=true&url=${publicRuntimeConfig.APP_URL + Routes.PublicPdfRegulations}`, '_blank')}
                            >
                                {translations?.previewAndDownloadButton}
                            </Button>
                        </header>
                        <div className="regulations-content">
                            <iframe
                                title="privacy policy users"
                                width="100%"
                                height="100%"
                                src={`${Routes.PublicPdfRegulations}#zoom=100&toolbar=0&view=FitH`}
                            />
                        </div>
                    </LayoutContainer>
                </section>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PageRegulationsSectionContent;
